module.exports = __webpack_public_path__ + "img/didacticiel-bottle.f7ad7a1d.svg";